import React, {useRef, useState} from 'react'
import ButtonGroup from '@material-ui/core/ButtonGroup';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import PropTypes from 'prop-types';
import Button from 'components/Button';
import {CircularProgress, withStyles} from "@material-ui/core";
import Tr from "translations/Translations";

const style = theme => ({
    root: {},
    zindex: {
        zIndex: 100
    }
})

function SplitButton(
    {
        className,
        buttonClassName,
        classes,
        label= Tr('additional_actions'),
        variant = 'contained',
        color = 'primary',
        working,
        disabled,
        buttons,//created by createButton
        hideEmpty
    }) {

    const [open, setOpen] = useState(false);
    const anchorRef = useRef(null);

    const handleClick = (event, index) => {
        setOpen(false);
        buttons[index].onClick();
    };

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
    };


    return (
        buttons.length === 0 && !!hideEmpty ?
            null
            : <>
            <ButtonGroup className={className} variant={variant} color={color} ref={anchorRef} >
                <Button className={buttonClassName} onClick={handleToggle} disabled={disabled}>{label}</Button>
                <Button
                    color="primary"
                    size="small"
                    disabled={disabled}
                    aria-controls={open ? 'split-button-menu' : undefined}
                    aria-expanded={open ? 'true' : undefined}
                    aria-haspopup="menu"
                    onClick={handleToggle}
                >
                    {working ? <CircularProgress size={24}/> : <ArrowDropDownIcon/>}
                </Button>
            </ButtonGroup>
            <Popper className={classes.zindex} open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal placement="bottom-end">
                <Paper>
                    <ClickAwayListener onClickAway={handleClose}>
                        <MenuList id="split-button-menu">
                            {buttons.map((button, index) => (
                                <MenuItem
                                    key={button.label}
                                    disabled={working || button.disabled}
                                    onClick={(event) => handleClick(event, index)}
                                >
                                    {button.label}
                                </MenuItem>
                            ))}
                        </MenuList>
                    </ClickAwayListener>
                </Paper>
            </Popper>
        </>
    )
}

SplitButton.propTypes = {
    className: PropTypes.string,
    classes: PropTypes.any,
    buttonClassName: PropTypes.string,
    label: PropTypes.string.isRequired,
    variant: PropTypes.oneOf(["text", "outlined", "contained"]),
    color: PropTypes.string,
    working: PropTypes.bool,
    disabled: PropTypes.bool,
    buttons: PropTypes.array.isRequired,//created by createButton
    hideEmpty:PropTypes.bool,
}

SplitButton.defaultProps = {}

export const createButton = (label, onClick, disabled = false) => ({
    label,
    onClick,
    disabled
});


export default withStyles(style)(SplitButton);